module.exports = __webpack_public_path__ + "img/no_data6.40eb7b0e.png";